import React from 'react'

const ConnectionStatus = ({ state }) => {
  return (
    <div className='ws-card'>
      <h5>Connection</h5>
      <div>
        <span className={`ws-pill ${state}`}>{state || 'unknown'}</span>
      </div>
      <div className='mt-2 small text-muted'>
        Reverb host:{' '}
        <code>
          {process.env.REACT_APP_REVERB_HOST || '(unset)'}:{process.env.REACT_APP_REVERB_PORT || '(unset)'}
        </code>
      </div>
      <div className='small text-muted'>
        App key:{' '}
        <code>
          {process.env.REACT_APP_REVERB_APP_KEY ? `${process.env.REACT_APP_REVERB_APP_KEY.slice(0, 8)}…` : '(unset)'}
        </code>
      </div>
    </div>
  )
}

export default ConnectionStatus
